import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import WholesaleLayout, { useWholesaleAuth, StatusBadge } from './WholesaleLayout';
import { getWholesaleOrders, getWholesaleUsers, wholesaleOrderAction } from '../../lib/api';

export default function WholesaleAdmin() {
  const user = useWholesaleAuth('admin');
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [users, setUsers] = useState([]);

  const load = () => {
    if (!user) return;
    getWholesaleOrders().then(r => setOrders(r.data)).catch(() => {});
    getWholesaleUsers().then(r => setUsers(r.data)).catch(() => {});
  };
  useEffect(load, [user]);

  const pending = orders.filter(o => o.status === 'pending');
  const approved = orders.filter(o => o.status === 'approved');
  const shipped = orders.filter(o => o.status === 'shipped');

  const doAction = async (oid, action) => {
    try {
      await wholesaleOrderAction(oid, { action });
      load();
    } catch (e) { alert(e.response?.data?.detail || 'Action failed'); }
  };

  const stats = [
    { label:'Pending Orders', value: pending.length, color:'#C41E2A' },
    { label:'Approved', value: approved.length, color:'#2E7D32' },
    { label:'Shipped', value: shipped.length, color:'#111' },
    { label:'Active Wholesalers', value: users.filter(u => u.is_active !== false).length, color:'#1565C0' },
  ];

  return (
    <WholesaleLayout user={user} title="Dashboard">
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:16, marginBottom:32 }}>
        {stats.map((s, i) => (
          <div key={i} data-testid={`stat-${i}`} style={{ background:'#fff', border:'1px solid #E0DED8', borderRadius:4, padding:'20px 24px' }}>
            <div style={{ fontSize:10, letterSpacing:2, textTransform:'uppercase', color:'#888', marginBottom:8 }}>{s.label}</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:32, fontWeight:700, color:s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24 }}>
        <div style={card}>
          <div style={cardTitle}>Pending Orders</div>
          {pending.length === 0 && <div style={{ color:'#888', fontSize:13 }}>No pending orders</div>}
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
            <tbody>
              {pending.slice(0, 10).map(o => (
                <tr key={o.id}>
                  <td style={td}><span style={{ fontWeight:600 }}>{o.id}</span><br/><span style={{ fontSize:11, color:'#888' }}>{o.wholesaler_name}</span></td>
                  <td style={td}>${o.total?.toLocaleString()}</td>
                  <td style={{ ...td, textAlign:'right' }}>
                    <button onClick={() => doAction(o.id, 'approve')} style={{ ...btnSm, background:'#2E7D32', color:'#fff', marginRight:6 }}>Approve</button>
                    <button onClick={() => doAction(o.id, 'reject')} style={{ ...btnSm, background:'#FCE4EC', color:'#B71C1C' }}>Reject</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={card}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
            <div style={cardTitle}>Recent Orders</div>
            <button onClick={() => navigate('/wholesale/admin/orders')} style={btnGhost}>View All</button>
          </div>
          {orders.slice(0, 10).map(o => (
            <div key={o.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 0', borderBottom:'1px solid #F0EEE8' }}>
              <div><span style={{ fontWeight:600, fontSize:13 }}>{o.id}</span> <span style={{ fontSize:11, color:'#888' }}>{o.wholesaler_name}</span></div>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <StatusBadge status={o.status} />
                <span style={{ fontSize:13, fontWeight:600 }}>${o.total?.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </WholesaleLayout>
  );
}

const card = { background:'#fff', border:'1px solid #E0DED8', borderRadius:4, padding:24 };
const cardTitle = { fontFamily:"'Barlow Condensed',sans-serif", fontSize:16, fontWeight:700, letterSpacing:1.5, textTransform:'uppercase', marginBottom:16 };
const td = { padding:'12px', borderBottom:'1px solid #E0DED8', verticalAlign:'middle' };
const btnSm = { display:'inline-flex', alignItems:'center', padding:'5px 10px', fontFamily:'Barlow', fontSize:11, fontWeight:600, letterSpacing:1, textTransform:'uppercase', borderRadius:2, cursor:'pointer', border:'none' };
const btnGhost = { display:'inline-flex', alignItems:'center', padding:'5px 10px', fontFamily:'Barlow', fontSize:11, fontWeight:600, letterSpacing:1, textTransform:'uppercase', borderRadius:2, cursor:'pointer', background:'transparent', color:'#888', border:'1px solid #E0DED8' };
